import { useFormik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { _ as GridRender } from "gridjs-react";
import { Button } from "react-bootstrap";
import ActionDropDown from "./ActionDropDown";
import DataGrid from "./DataGrid";
import ActiveInactive from "./ActiveInactive";
import { SORT_LIST_ADMIN, STATUS_LIST_ADMIN } from "../../constants/options";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../../styles/components/Admin/StateDetails.scss";
import { PAGE } from "../../constants/page";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { updateBreadcrum } from "../../redux/reducers/BreadcrumbSlice";
import AdminPopUp from "./AdminPopUp";
import { API } from "../../constants/api";
import {
  ApiCallWithLoader,
  errorUpdate,
} from "../../redux/reducers/LoaderSlice";
import { selectedStatePractioner } from "../../redux/reducers/PractionerRoleIdsSlice";
import HttpService from "../../services/HttpService";
import Pagination from "../Pagination";
import { Trans } from "react-i18next";
import { UserState, hideSuccessMessage } from "../../redux/reducers/UserSlice";
import i18next from "i18next";
import Utility from "../../utility/Utility";
import SuccessMessage from "../SuccessMessage";
import { PersistState } from "../../redux/reducers/PersistSlice";
import ErrorBoundaryHandler from "../ErrorBoundaryHandler";
import AdminSearch from "./AdminSearch";
import { ROLE } from "../../constants/role";
import LeydenSelect from "../LeydenSelect";
import NameEllipses from "./NameEllipses";

function StateDetails() {
  const [searchAdmin, setSearchAdmin] = useState<any>([]);
  const [pop, setPopUp] = useState(false);
  const [adminValue, setAdminValue] = useState<any>({});
  const [statusValue, setStatusValue] = useState("");
  const [deactivate, setDeactivate] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [totalResults, setTotalResults] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const userDetails: any = useAppSelector(UserState);
  const userSelectedLanguage: any = useAppSelector(PersistState);
  const selectedState = useAppSelector(selectedStatePractioner);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = useParams();
  const userType: string = location.pathname.split("/").pop() || "";
  const [practitionerId, setPractitionerId] = useState("");
  const pageUrl = PAGE.VIEW_USERS.replace(":userType", "admin");
  const stateName: string = state?.replace(/%20/g, " ") || "";
  const userRole = Utility.getUserRole(
    userDetails?.userDetails?.app_metadata?.organizations?.EODB?.groups[0]
  );

  const fetchAdmins = async (
    pageNumber: number,
    status = "",
    searchText = "",
    sortValue = "name",
    sortType = "asc",
    practId?: any
  ) => {
    try {
      let sortTypeConvert;
      if (sortValue === "created_at") {
        sortTypeConvert = sortType === "asc" ? "-1" : "1";
      } else {
        sortTypeConvert = sortType === "asc" ? "1" : "-1";
      }

      const _requestData = {
        roles: "State Admin",
        statePractitionerID: practId || practitionerId,
        district: "",
        status: status,
        searchText,
        per_page: 10,
        page: pageNumber,
        include_totals: true,
        sortQuery: `${sortValue}:${sortTypeConvert}`,
      };
      const requestDetails = {
        url: `${API.USERS_BY_ROLES}`,
        method: "POST",
        requestData: _requestData,
        callType: "auth0",
      };
      const resp = await dispatch(ApiCallWithLoader(requestDetails));
      setSearchAdmin(resp?.payload.users || []);

      if (pageNumber === 0) {
        setTotalResults(resp?.payload.total || 0);
      }
    } catch (error) {
      dispatch(errorUpdate({ isError: true, error: error }));
    }
  };

  const getStatePractitionerId = async (stateId: any) => {
    return new Promise<void>(async (resolve, reject) => {
      try {
        const roleRequest_url = `${API.PRACTITIONER_ROLES}&location=Location/${stateId}`;
        const requestDetails = {
          url: roleRequest_url,
          method: "GET",
        };
        const practionerRoleResp = await dispatch(
          ApiCallWithLoader(requestDetails)
        );
        setPractitionerId(practionerRoleResp.payload.entry[0].resource.id);
        resolve(practionerRoleResp.payload.entry[0].resource.id);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  };

  useEffect(() => {
    if (selectedState?.stateId?.value) {
      setPageNumber(1);
      formik.setFieldValue("searchInput", "");
      formik.setFieldValue("status", "");
      formik.setFieldValue("sortValue", "name");
      formik.setFieldValue("sortType", "asc");
      getStatePractitionerId(selectedState?.stateId?.value).then(
        async (stateId: any) => {
          await fetchAdmins(0, "", "", "name", "asc", stateId);
        }
      );
    }
  }, [selectedState]);

  const handlePopUp = (value: boolean) => {
    setPopUp(value);
  };

  const handleDeactivateUser = async () => {
    try {
      const requestDetails = {
        url: API.USER_CHANGE_STATUS,
        method: "POST",
        callType: "auth0",
        requestData: {
          user_id: adminValue.userID,
          status: statusValue === "activate" ? "unblock" : "block",
        },
      };

      setShowAlert(false);
      const resp = await dispatch(ApiCallWithLoader(requestDetails));
      if (resp) {
        setDeactivate(true);
        setShowAlert(true);
        setPopUp(false);
        const updatedList = searchAdmin.map((adminDetails: any) => {
          if (adminDetails.user_id === adminValue.userID) {
            adminDetails.blocked = statusValue === "deactivate" ? true : false;
          }
          return adminDetails;
        });
        setSearchAdmin([...updatedList]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlActionClick = (rowData: any, actionValue: any) => {
    if (actionValue === "viewDetails") {
      dispatch(
        updateBreadcrum({
          routeHistory: [
            {
              label: "Admin",
              label_key: "admin",
              path: PAGE.GLOBAL_STATE_ADMIN.replace(
                ":state",
                state || ""
              ).concat("/admin"),
              id: "admin_main",
              value: "",
            },
          ],
          display: true,
        })
      );

      const routeLink = pageUrl.replace(":userName", rowData?._cells[0].data);
      navigate(routeLink, {
        state: {
          email: rowData._cells[4].data,
          authID: rowData._cells[5].data,
          userRole: userRole,
        },
      });
    } else if (actionValue === "deactivate" || actionValue === "activate") {
      dispatch(hideSuccessMessage(false));
      setStatusValue(actionValue);
      handlePopUp(true);
      setShowAlert(false);
      setAdminValue({
        name: rowData?._cells[0].data,
        userID: rowData._cells[5].data,
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      searchInput: "",
      status: "",
      sortValue: "name",
      sortType: "asc",
    },
    onSubmit: async (values: any) => {
      setPageNumber(1);
    },
  });

  const GridColumn: any[] = [
    {
      id: "name",
      name: i18next.t("grid.admin_name"),
      formatter: (_cell: any, row: any) => {
        const ActionList = row.cells[0].data;
        if (ActionList.length >= 22) {
          return GridRender(
            <NameEllipses
              actionList={ActionList}
              toggleName={ActionList}
              id={row.cells[0]._id}
              tabType="admin"
            />
          );
        } else {
          return ActionList;
        }
      },
    },
    {
      id: "username",
      name: i18next.t("grid.admin_id"),
      data: (cell: any) => {
        return cell?.username?.toUpperCase();
      },
    },
    {
      id: "app_metadata",
      name: i18next.t("grid.phone_number"),
      formatter: (_cell: any, _row: any) => {
        return _cell.phone_number;
      },
    },
    {
      id: "blockedStatus",
      name: i18next.t("grid.status"),
      data: (cell: any) => {
        const app_metaData = cell.app_metadata;
        const statusValue = cell?.blocked ? true : false;
        const blockerFor = cell?.blocked_for;
        const statusData = Utility.getStatusValue(
          statusValue,
          app_metaData,
          blockerFor
        );
        return statusData;
      },
      formatter: (_: any, row: any) => {
        const app_metaData = _?.app_metadata ? _.app_metadata : "";
        const statusValue = row.cells[3].data ? row.cells[3].data : "";
        return GridRender(<ActiveInactive statusValue={statusValue} />);
      },
    },
    {
      id: "email",
      name: "Email",
      hidden: true,
    },
    {
      id: "user_id",
      name: "User ID",
      hidden: true,
    },
    {
      id: "blocked",
      name: "blocked",
      hidden: true,
    },
    {
      id: "action",
      name: i18next.t("grid.action"),
      formatter: (_cell: any, row: any) => {
        const statusValue = row.cells[3].data ? row.cells[3].data : "Inactive";
        let ActionList: any = [
          {
            value: i18next.t("grid.view_details"),
            action: "viewDetails",
          },
        ];
        if (userRole !== ROLE.GLOBAL_ADMIN_SUPPORT) {
          if (statusValue === "Active") {
            ActionList.push({
              value: i18next.t("grid.deactivate"),
              action: "deactivate",
            });
          } else if (statusValue === "Inactive") {
            ActionList.push({
              value: i18next.t("grid.activate"),
              action: "activate",
            });
          }
        }
        return GridRender(
          <ActionDropDown
            actionList={ActionList}
            row={row}
            onActionClick={handlActionClick}
            useLeyden={true}
          />
        );
      },
    },
    {
      id: "blocked_for",
      name: "blocked_for",
      hidden: true,
    },
  ];

  const navigateToDetails = (routeEndValue: string) => {
    dispatch(
      updateBreadcrum({
        routeHistory: [
          {
            label: "Admins",
            label_key: "admins",
            path: PAGE.GLOBAL_STATE_ADMIN.replace(":state", state || "").concat(
              "/admin"
            ),
            id: "admins",
            value: "",
          },
        ],
        display: true,
      })
    );
    const routeLink = PAGE.ADD_USERS.replace(":userId", routeEndValue);
    navigate(routeLink);
  };

  const handleRemoveSuccessMessage = (e?: any) => {
    setShowAlert(false);
  };

  const memoDataGrid = useMemo(() => {
    return <DataGrid columnData={GridColumn} cellData={searchAdmin} />;
  }, [searchAdmin, userSelectedLanguage?.language]);

  const applyFilter = async () => {
    handleRemoveSuccessMessage();
    setPageNumber(1);
    await fetchAdmins(
      0,
      formik.values.status,
      formik.values.searchInput,
      formik.values.sortValue,
      formik.values.sortType
    );
  };

  const handlePageChange = async (e: any) => {
    handleRemoveSuccessMessage();
    setShowAlert(false);
    setPageNumber(e.selected + 1);
    await fetchAdmins(
      e.selected,
      formik.values.status,
      formik.values.searchInput,
      formik.values.sortValue,
      formik.values.sortType
    );
  };

  // this is Triggered on enter button or icon click
  const onSearch = async (searchText: string) => {
    handleRemoveSuccessMessage();
    setPageNumber(1);
    formik.setFieldValue("searchInput", searchText);
    await fetchAdmins(
      0,
      formik.values.status,
      searchText,
      formik.values.sortValue,
      formik.values.sortType
    );
  };
  const onInput = async (searchText: any) => {
    if (searchText.length === 0) {
      handleRemoveSuccessMessage();
      setPageNumber(1);
      formik.setFieldValue("searchInput", "");
      await fetchAdmins(
        0,
        formik.values.status,
        "",
        formik.values.sortValue,
        formik.values.sortType
      );
    }
  };
  const onSortIconCLick = async () => {
    handleRemoveSuccessMessage();
    setPageNumber(1);
    if (formik.values.sortType === "asc") {
      formik.setFieldValue("sortType", "dec");
      await fetchAdmins(
        0,
        formik.values.status,
        formik.values.searchInput,
        formik.values.sortValue,
        "dec"
      );
    } else {
      formik.setFieldValue("sortType", "asc");
      await fetchAdmins(
        0,
        formik.values.status,
        formik.values.searchInput,
        formik.values.sortValue,
        "asc"
      );
    }
  };
  const sortDropDownChange = async (sort: any) => {
    setPageNumber(1);
    handleRemoveSuccessMessage();
    let sortFinalValue = sort?.value ? sort?.value : "name";
    formik.setFieldValue("sortValue", sortFinalValue);
    await fetchAdmins(
      0,
      formik?.values?.status,
      formik?.values?.searchInput,
      sortFinalValue,
      formik?.values?.sortType
    );
  };

  return (
    <div className="container">
      <div className="stateDetails">
        <AdminSearch
          placeholderKey="placeholder.search_admin"
          onSearch={onSearch}
          onInput={onInput}
        />
        <div className="applyContainer">
          <LeydenSelect
            label={"Select Status"}
            label_key="select_status"
            options={Utility.getOptions(STATUS_LIST_ADMIN)}
            onChange={(status: any) =>
              formik.setFieldValue("status", status?.value)
            }
            id={"status"}
            defaultSelected={formik.values.status}
            error={formik.errors.status}
            mandate={false}
            blankOptionLabel={"All"}
          />
          <Button
            className="btn-outline apply_filter_admin"
            onClick={applyFilter}
          >
            <Trans i18nKey={"apply_filter"} />
          </Button>
        </div>
      </div>
      {deactivate === true &&
      showAlert &&
      userDetails.successMessage === false ? (
        <SuccessMessage
          stateAdminActivateDectivate={adminValue.name}
          statusVal={
            statusValue.toLocaleLowerCase() === "activate"
              ? "activated"
              : "deactivated"
          }
          onIconClose={() => {
            setShowAlert(false);
          }}
        />
      ) : null}
      <AdminPopUp
        show={pop}
        handelClose={() => {
          handlePopUp(false);
        }}
        handleOnSubmit={() => handleDeactivateUser()}
        title_key={`${statusValue}_user`}
        body={
          <>
            <Trans i18nKey={"are_you_sure_you_want"} />{" "}
            <span className="text-capitalize">
              <Trans i18nKey={statusValue?.toLowerCase()} />
            </span>{" "}
            <b>{adminValue.name}</b> ?
          </>
        }
        primaryButtonTitle_key={statusValue}
        secondaryButtonTitle_key="Cancel"
      />
      <div
        className={
          deactivate === true &&
          showAlert &&
          userDetails.successMessage === false
            ? "listSortStateAdmin successMarginTopStateAdmins"
            : "listSortStateAdmin"
        }
      >
        <h3>
          <Trans i18nKey={"list_of_admins_in"} />{" "}
          {stateName.replace(/%20/g, " ")}
        </h3>
        <div className="state_admin_sort_add">
          <span className="adminSortTitle">
            <Trans i18nKey={"sort_by"} />
          </span>
          <LeydenSelect
            label={" "}
            options={Utility.getOptions(SORT_LIST_ADMIN)}
            onChange={sortDropDownChange}
            id={"sort_admin"}
            defaultSelected={formik.values.sortValue}
            error={formik.errors.sortValue}
            mandate={false}
            blankOptionLabel={"name"}
            isLabelInline={true}
          />
          <img
            src="/icons/SortAsc.svg"
            alt="sort_icon"
            onClick={onSortIconCLick}
            className={
              formik.values.sortType === "asc"
                ? "admin-asc-img"
                : "admin-dec-img"
            }
          />
          {userRole !== ROLE.GLOBAL_ADMIN_SUPPORT && (
            <>
              <img
                src="/icons/DividerAdmin.svg"
                alt="divider_icon"
                className="divider_admin"
              />
              <Button
                type="button"
                data-testid="addAdmin"
                className="addAdminsBtn"
                onClick={() => navigateToDetails("admin")}
              >
                <Trans i18nKey={"add_admins"} />
              </Button>
            </>
          )}
        </div>
      </div>
      <div>{memoDataGrid}</div>
      <div className="mt-2" style={{ marginBottom: "150px" }}>
        {totalResults > 0 && (
          <Pagination
            totalResultsFound={totalResults}
            pageNumber={pageNumber}
            pageCount={Math.ceil(totalResults / 10)}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
}

export default ErrorBoundaryHandler(StateDetails);
